import { render, staticRenderFns } from "./cnkiResult.vue?vue&type=template&id=166e38e6&scoped=true&"
import script from "./cnkiResult.vue?vue&type=script&lang=js&"
export * from "./cnkiResult.vue?vue&type=script&lang=js&"
import style0 from "./cnkiResult.vue?vue&type=style&index=0&id=166e38e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e38e6",
  null
  
)

export default component.exports